import { useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { useGetAllCategories } from "../../../../../api/jeep-rally/categories/categories.hooks";
import {
  filterCategories,
  getCategoryApiErrorMessage,
  isJeepRallyAdmin,
  normalizeCategories,
} from "../utils/category.utils";
import CategoriesHeader from "./_components/CategoriesHeader";
import CategoriesTable from "./_components/CategoriesTable";

const CategoriesListPage = () => {
  const history = useHistory();
  const canManage = isJeepRallyAdmin();
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const { data, isLoading, isError, error } = useGetAllCategories({
    status: statusFilter,
  });

  const categories = useMemo(() => normalizeCategories(data), [data]);

  const filteredCategories = useMemo(() => {
    return filterCategories(categories, searchTerm);
  }, [categories, searchTerm]);

  const handleView = (category) => {
    const categoryId = category?._id || category?.id;
    if (!categoryId) return;
    history.push(`/jeep-rally/categories/view/${categoryId}`, { category });
  };

  const handleEdit = (category) => {
    const categoryId = category?._id || category?.id;
    if (!categoryId) return;
    history.push(`/jeep-rally/categories/edit/${categoryId}`, { category });
  };

  if (isLoading) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-center py-5">
              <Spinner animation="border" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body text-danger py-4">
            Failed to load categories.{" "}
            {getCategoryApiErrorMessage(error, "Please try again.")}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="card">
        <CategoriesHeader
          searchTerm={searchTerm}
          onSearchChange={setSearchTerm}
          statusFilter={statusFilter}
          onStatusFilterChange={setStatusFilter}
          total={filteredCategories.length}
          canManage={canManage}
          onAddCategory={() => history.push("/jeep-rally/categories/create")}
        />
        <div className="card-body">
          {filteredCategories.length === 0 ? (
            <div className="text-center py-4">
              <p className="text-muted mb-0">No categories found</p>
            </div>
          ) : (
            <CategoriesTable
              categories={filteredCategories}
              onView={handleView}
              onEdit={handleEdit}
              canManage={canManage}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CategoriesListPage;
